import React, { useEffect, useState } from "react";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";

import "./SkeletonAttachment.scss";

interface Props {
  fileName: string;
}

export default function SkeletonAttachment({ fileName }: Props) {
  const [progress, setProgress] = useState(0);
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          setIsProcessing(true);
          return 100;
        }

        const increment = Math.random() * 10 + 2;
        return Math.min(prev + increment, 100);
      });
    }, 5000 / 100);

    return () => clearInterval(interval);
  }, []);

  return (
    <li className="skeleton-attachment">
      <div className="skeleton-attachment__icon-container" />

      <div className="skeleton-attachment__content">
        <div className="skeleton-attachment__filename">{fileName}</div>

        <div className="skeleton-attachment__progress-container">
          <div
            className="skeleton-attachment__progress-bar"
            style={{ width: `${progress}%` }}
          />
        </div>

        <div className="skeleton-attachment__status">
          <div className="skeleton-attachment__spinner" />
          {isProcessing ? (
            <IDHFormattedMessage
              id="ws_processing"
              defaultMessage="Processing"
            />
          ) : (
            <IDHFormattedMessage id="ws_uploading" defaultMessage="Uploading" />
          )}
          {!isProcessing && `${Math.round(progress)}%`}
        </div>
      </div>

      <div className="skeleton-attachment__actions">
        <button
          className="skeleton-attachment__action button-style-reset"
          disabled
          type="button"
        >
          &nbsp;
        </button>
        <button
          className="skeleton-attachment__action button-style-reset"
          disabled
          type="button"
        >
          &nbsp;
        </button>
      </div>
    </li>
  );
}
